import { render, staticRenderFns } from "./vip-favi-list.vue?vue&type=template&id=70c74cf4&scoped=true&"
import script from "./vip-favi-list.vue?vue&type=script&lang=js&"
export * from "./vip-favi-list.vue?vue&type=script&lang=js&"
import style0 from "./vip-favi-list.vue?vue&type=style&index=0&id=70c74cf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c74cf4",
  null
  
)

export default component.exports